import { alpha, TableCell, TableRow } from "@mui/material";
import { useState } from "react";
import { ASSETS_COLORS } from "src/theme/palette";

import CollapseTable from "./CollapseTable/CollapseTable";
import cols from "./Cols";
import Context, { ContextType } from "./contextRow";
import { Position } from "./hooks/useGetPositionRows";

export default function Row(props: Position) {
	const [isCollapsed, setIsCollapsed] = useState(false);

	const onChangeCollapse = () => {
		setIsCollapsed(!isCollapsed);
	};

	const contextValue: ContextType = {
		positions: props.children,
		isCollapsed,
		actions: { onCollapse: onChangeCollapse }
	};

	return (
		<Context.Provider value={contextValue}>
			<TableRow hover>
				{cols.map(({ Cell, align }, index) => (
					<TableCell
						align={align}
						key={index}
						sx={{
							backgroundColor: isCollapsed ? alpha(ASSETS_COLORS.greyDark.light, 0.08) : "none"
						}}
						width={"12.5%"}
					>
						<Cell {...props} />
					</TableCell>
				))}
			</TableRow>
			<TableRow hover>
				<CollapseTable />
			</TableRow>
		</Context.Provider>
	);
}
